export enum TabsMain {
  QUELLEN = 0,
  WINDDATEN = 1,
}